/* ============ */
/*   APP.JS     */
/* ============ */

import { useState, useEffect, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
/*import { useAuth } from './context/AuthContext';*//*comentado porque ya no uso login*/

import SEO from "./components/SEO";
import Navbar from "./components/Navbar";
import WelcomeSection from "./components/WelcomeSection";
import AboutSection from "./components/AboutSection";
import Colaboraciones from "./components/Colaboraciones";
import Footer from "./components/Footer";
import ProjectSection from "./components/ProjectSection";
import PoliticaPrivacidad from './components/footer-pages/PoliticaPrivacidad';
import UsoCookies from './components/footer-pages/UsoCookies';
import CondicionesUso from './components/footer-pages/CondicionesUso';
import AvisosLegales from './components/footer-pages/AvisosLegales';
import MapaSitio from './components/footer-pages/MapaSitio';
import NeuroGlintPage from './components/NeuroGlintPage';
import MoveSparkPage from './components/MoveSparkPage';
import ScrollToTop from './components/ScrollToTop';
import BackToTopButton from "./components/BackToTopButton";
import AccessibilityWidget from "./components/AccessibilityWidget";
import ContactView from './contact/ContactView';
import MasAlla from './components/MasAlla';
import SparklingSocial from './components/SparklingSocial';
import SocialMediaWall from './components/social/SocialMediaWall';
import CustomCookieConsent from './components/CustomCookieConsent';
import HomeProjects from './components/HomeProjects';
import HomeImpact from './components/HomeImpact';
import { TeamSection } from './components/TeamSection';
import FloatingLines from './components/FloatingLines';

import "./components/Navbar.css";
import "./components/WelcomeSection.css";
import "./components/Footer.css";
import "./App.css";

/* =========  Protege la ruta /admin ========== */
/*const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Navigate to="/login" />;
};*/

function AppContent() {
  const location = useLocation();

  const isHome = location.pathname === "/";

  const mainRef = useRef(null);
  const [routeAnnouncement, setRouteAnnouncement] = useState('');

  useEffect(() => {
    if (mainRef.current) {
      mainRef.current.focus({ preventScroll: true });
    }
    const timer = setTimeout(() => {
      setRouteAnnouncement(document.title);

      if (typeof window.gtag === 'function') {
        window.gtag('event', 'page_view', {
          page_title: document.title,
          page_location: window.location.href,
          page_path: location.pathname + location.search,
        });
      }
    }, 150);
    return () => clearTimeout(timer);
  }, [location.pathname, location.search]);

  return (
    <div style={{ paddingTop: isHome ? "0px" : "70px" }}>
      <a href="#main-content" className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[999] focus:bg-white focus:text-black focus:px-4 focus:py-2 focus:rounded">
        Saltar al contenido principal
      </a>

      <Navbar />

      <div aria-live="polite" role="status" className="sr-only">
        {routeAnnouncement}
      </div>

      <main id="main-content" ref={mainRef} tabIndex={-1} style={{ outline: 'none' }}>
      <Routes>
        {/* Home */}
        <Route
          path="/"
          element={
            <>
              <SEO
                title="Innovación y Futuro"
                description="Sparkling Tech Solutions desarrolla tecnología con base científica: ADAIA (IA emocional), NeuroGlint (neurociencia aplicada) y Patrimonio Vivo (memoria y patrimonio cultural)."
                path="/"
              />
              <WelcomeSection />
              <HomeImpact />
              <HomeProjects />
              <TeamSection />
              <Colaboraciones />
            </>
          }
        />

        {/* Páginas informativas */}
        <Route path="/about" element={
          <>
            <SEO
              title="Quiénes somos"
              description="Conoce al equipo de Sparkling Tech Solutions y nuestro laboratorio de I+D+i en neurociencia, inteligencia artificial y videojuegos aplicados a la salud y el bienestar."
              path="/about"
            />
            <AboutSection />
          </>
        } />
        <Route path="/politica-privacidad" element={
          <>
            <SEO title="Política de Privacidad" description="Política de privacidad de Sparkling Tech Solutions." path="/politica-privacidad" />
            <PoliticaPrivacidad />
          </>
        } />
        <Route path="/uso-cookies" element={
          <>
            <SEO title="Uso de Cookies" description="Información sobre el uso de cookies en la web de Sparkling Tech Solutions." path="/uso-cookies" />
            <UsoCookies />
          </>
        } />
        <Route path="/condiciones-de-uso" element={
          <>
            <SEO title="Condiciones de Uso" description="Condiciones de uso de la web de Sparkling Tech Solutions." path="/condiciones-de-uso" />
            <CondicionesUso />
          </>
        } />
        <Route path="/avisos-legales" element={
          <>
            <SEO title="Avisos Legales" description="Aviso legal de Sparkling Tech Solutions." path="/avisos-legales" />
            <AvisosLegales />
          </>
        } />
        <Route path="/mapa-sitio" element={
          <>
            <SEO title="Mapa del Sitio" description="Mapa del sitio de Sparkling Tech Solutions." path="/mapa-sitio" />
            <MapaSitio />
          </>
        } />

        {/* Proyectos */}
        <Route path="/projects" element={
          <>
            <SEO
              title="Proyectos"
              description="Descubre ADAIA, NeuroGlint y Patrimonio Vivo: soluciones tecnológicas de Sparkling Tech Solutions basadas en neurociencia, inteligencia artificial y ciencia de datos."
              path="/projects"
            />
            <ProjectSection />
          </>
        } />
        <Route path="/projects/neuroglint" element={
          <>
            <SEO
              title="NeuroGlint"
              description="NeuroGlint: neurociencia aplicada que transforma señales emocionales en datos estratégicos mediante inteligencia artificial."
              path="/projects/neuroglint"
            />
            <NeuroGlintPage />
          </>
        } />
        <Route path="/movespark" element={
          <>
            <SEO
              title="MoveSpark Lab"
              description="MoveSpark Lab: nuestro laboratorio de investigación en videojuegos terapéuticos, salud cerebral y tecnología aplicada al bienestar."
              path="/movespark"
            />
            <MoveSparkPage />
          </>
        } />

        {/* Otros */}
        <Route path="/contacto" element={
          <>
            <SEO
              title="Contacto"
              description="Contacta con Sparkling Tech Solutions para hablar de tu idea o proyecto en neurociencia, inteligencia artificial o innovación tecnológica."
              path="/contacto"
            />
            <ContactView />
          </>
        } />
        <Route path="/mas-alla-del-id" element={
          <>
            <SEO
              title="Más allá del I+D+i"
              description="Cómo Sparkling Tech Solutions convierte la investigación científica en soluciones reales con impacto social."
              path="/mas-alla-del-id"
            />
            <MasAlla />
          </>
        } />
        <Route path="/sparkling-social" element={
          <>
            <SEO
              title="Sparkling Social"
              description="El compromiso social de Sparkling Tech Solutions: tecnología con propósito para transformar la sociedad."
              path="/sparkling-social"
            />
            <SparklingSocial />
          </>
        } />

        {/* Blog / Social Media Wall */}
        <Route path="/nuestras-redes" element={
          <>
            <SEO
              title="Nuestras Redes"
              description="Sigue la actualidad de Sparkling Tech Solutions en redes sociales."
              path="/nuestras-redes"
            />
            <SocialMediaWall />
          </>
        } />

      {/* { Auth / Admin }
      <Route path="/login" element={<LoginForm />} /> */} {/* Esto se eliminó porque no importaba cómo se modificara la tabla de usuario, no se actualizaba. */}

{/*<Route
  path="/admin"
  element={
    <ProtectedRoute>
      <BlogForm />
    </ProtectedRoute>
  }
/>

<Route
  path="/admin/:id"
  element={
    <ProtectedRoute>
      <BlogForm />
    </ProtectedRoute>
  }
/>*/}

      </Routes>
      </main>

        {/*Consentimiento de cookies*/}
<CustomCookieConsent />

      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <BackToTopButton />
      <AccessibilityWidget />
      <AppContent />
    </Router>
  );
}

export default App;
